var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinusCircle = function SvgMinusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8.168h-5a.836.836 0 0 0-.834.833c0 .459.375.834.833.834h5A.836.836 0 0 0 12.333 9a.836.836 0 0 0-.834-.833Zm-2.5 7.5a6.675 6.675 0 0 1-6.667-6.667 6.674 6.674 0 0 1 6.666-6.666A6.674 6.674 0 0 1 15.666 9a6.674 6.674 0 0 1-6.667 6.667Zm0-15C4.403.668.665 4.406.665 9.001c0 4.595 3.738 8.334 8.333 8.334 4.595 0 8.334-3.739 8.334-8.334S13.594.668 8.999.668Z",
    fill: "#D6D6D6"
  })));
};
export default SvgMinusCircle;